export default __webpack_public_path__ + "static/media/serena_duncan.2822af57.jpg";